import React, { useState, useMemo, useEffect, useRef } from "react";
import MainWrapper from "../../MainWrapper";
import Title from "../../elements/Title";
import { Icon } from "react-icons-kit";
import { Link, useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { ic_arrow_back } from "react-icons-kit/md";
import { connect } from "react-redux";
import { CUSTOMER_LIST_REQUEST } from "../../../_utils/constants/Customer";
import { STORE_INFO_REQUEST } from "../../../_utils/constants/admin/StoreInfo";
import CustomerList from "./CustomerList";
import _ from "lodash";

const Customer = ({
	auth: { auth, isAuthenticated },
	customerInfo: { customerList, totalCount },
	StoreInfo: { storeInfo },
	fetchCustomerList,
	fetchStoreInfo,
	handlePropertyClick
}) => {

	// Optional drill-down filters forwarded via the query string (used by the
	// "New Customers Secured" dashboard widget → /new-customers-secured-info).
	// The other customer-grid routes pass no query params, so these stay empty
	// and the listing behaves exactly as before.
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const qpFromDate = searchParams.get("fromDate") || "";
	const qpToDate = searchParams.get("toDate") || "";
	const qpSalesPerson = searchParams.get("salesPerson") || "";
	const qpSalesPersonId = searchParams.get("salesPersonId") || "";

	// The "New Customers Secured" widget drills into this same grid via the
	// /new-customers-secured-info route. Only that route sources its rows from the
	// dedicated NewCustomerList endpoint; every other customer route keeps using
	// the standard GetCustomerInfo listing.
	const isNewCustomerSecured = location.pathname === "/new-customers-secured-info";

	// states declaration
	const [sort, setSort] = useState("asc");
	const [page, setPage] = useState(1);
	const [paginate, setPaginate] = useState(20);

	const initialFilterState = {
		"sortOn": "",
		"salesPerson": qpSalesPerson,
		"shipToPropertyName": "",
		"shipToManagementCompany": "",
		"shipToAddress": "",
		"shipToState": "",
		"shipToCity": "",
		"StoreId": "",
		"fromDate": qpFromDate,
		"toDate": qpToDate
	};

	// listParamState updates instantly (keeps inputs responsive)
	const [listParamState, setListParamState] = useState(initialFilterState);
	// debouncedListParamState is what actually triggers the API call
	const [debouncedListParamState, setDebouncedListParamState] = useState(initialFilterState);

	const debouncedSetFilter = useRef(
		_.debounce((newState) => setDebouncedListParamState(newState), 500)
	).current;

	useEffect(() => {
		return () => debouncedSetFilter.cancel();
	}, []);

	const navigate = useNavigate();

	useEffect(() => {
		if (!isAuthenticated) {
			navigate("/login")
		}
	}, [auth, isAuthenticated])

	// function called to show updated listing
	const customerListing = useMemo(() => {
		if(customerList && localStorage.getItem('Customer-Listing')) {
			let arr = []
			localStorage.removeItem('Customer-Listing')
			return arr
		} else {
			return customerList
		}
	} ,[customerList]) 

	// function to check whether user is authenticated or not, if yes then call store list api
	useEffect(() => {
		if (isAuthenticated) fetchStoreInfo(auth[0].token);
	}, [auth, isAuthenticated]);

	// function to call customer list api (uses debounced state to avoid firing on every keystroke)
	useEffect(() => {
		if (isAuthenticated) {
			fetchCustomerList(auth[0].token, sort, page, paginate, debouncedListParamState, auth[0].userId, qpSalesPersonId || false, false, false, isNewCustomerSecured);
		}
	}, [auth, isAuthenticated, sort, page, paginate, debouncedListParamState]);

	// function called on any filter value change
	const handleFilterChange = (e) => {
		const { id, value } = e.target;
		const newState = { ...listParamState, [id]: value };
		setListParamState(newState);        // instant update so input stays responsive
		debouncedSetFilter(newState);       // delayed update triggers the API after 500ms
	}

	// function to manage store list data fetched
	const storeList = useMemo(() => {
		if (storeInfo)
			return storeInfo.map(v => ({ label: v.storeName, value: v.storeId }))
	}, [storeInfo])
	
	return (
		<MainWrapper>
			<div className="container">
				<div className="sub-header mt-5 mb-3">
					<Title>Customer List</Title>
					<Link className="btn btn-primary me-1" to={qpFromDate !== "" ? "/dashboard" :"/admin"}><Icon icon={ic_arrow_back} />Back</Link>
				</div>
				<CustomerList
					customerList={customerListing}
					totalCount={totalCount}
					setSort={setSort}
					setPaginate={setPaginate}
					setPage={setPage}
					page={page}
					paginate={paginate}
					listParamState={listParamState}
					handleFilterChange={handleFilterChange}
					storeList={storeList}
					handlePropertyClick={handlePropertyClick}
				/>
			</div>
		</MainWrapper>
	)
}
const mapStateToProps = ({ auth, customerInfo, StoreInfo }) => {
	return {
		auth, customerInfo, StoreInfo
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		fetchCustomerList: (token, sort, page, paginate, listParamState, userId, salesPersonId, GrpPcId, isChecked, isNewCustomerSecured) => dispatch({ type: CUSTOMER_LIST_REQUEST, token, sort, page, paginate, listParamState, userId, salesPersonId, GrpPcId, isChecked, isNewCustomerSecured }),
		fetchStoreInfo: (token) => dispatch({ type: STORE_INFO_REQUEST, token }),
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(Customer);